import React, { useEffect, useState } from 'react';
import '../assets/css/AstroWelcomePage.css';
import posthog from 'posthog-js';
import IconImage1 from '../assets/images/LOVE.svg';
import IconImage3 from '../assets/images/career.svg';
import IconImage2 from '../assets/images/wealth.svg';
import IconImage4 from '../assets/images/foreign.svg';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import api from '../api/axios';
import { BackgroundDiv } from '../components/StyledComponents';
import { Box, Typography, Grid, Paper, Button, Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const categories = [
  {
    title: 'Marriage & Love',
    topColor: '#ef476f',
    bottomColor: '#fcd2db',
    disabled: false,
    emoji: '❤️',
    icon: IconImage1, // Replace with an icon or img
  },
  {
    title: 'Career',
    topColor: '#00b4d8',
    bottomColor: '#d0f1fb',
    disabled: true,
    emoji: '💼',
    icon: IconImage3, // Replace with an icon or img
  },
  {
    title: 'Wealth & Finances',
    topColor: '#ff8800',
    bottomColor: '#ffe5cc',
    disabled: true,
    emoji: '💰',
    icon: IconImage2, // Replace with an icon or img
  },
  {
    title: 'Foreign Education',
    topColor: '#2e8b57',
    bottomColor: '#e3fce7',
    disabled: true,
    emoji: '📚',
    icon: IconImage4, // Replace with an icon or img
  },
];

const AstroWelcome = () => {
  const [email, setEmail] = useState('');
  const [showData, setData] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decoded = jwtDecode(token);
      const id = decoded.email;

      axios
        .get(`${api}/user/details/${id}`)
        .then((res) => {
          setEmail(res.data[0].email);
        })
        .catch((err) => {
          console.error('Failed to fetch user email:', err);
        });
    }
  }, []);
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <BackgroundDiv saturn={true}>
      <Navbar />
      <Box sx={{ minHeight: '100vh', py: 6, px: 2, textAlign: 'center' }}>
        <Typography sx={{ fontSize: '50px', fontWeight: 500 }} gutterBottom>
          Welcome to{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          We Specialise in Giving you Accurate Prediction
        </Typography>
        <Typography variant="body1" sx={{ mb: 6 }}>
          Select the area you need guidance in ✨
        </Typography>

        <div className="card-grid">
          {categories.map((card, index) => (
            <div
              key={index}
              className="astro-card"
              onClick={() => {
                if (card.disabled) return;
                posthog.capture('onboarding_category_selected', {
                  category: card.title,
                });
                navigate('/chat');
              }}
              style={{
                backgroundColor: card.topColor,
                opacity: card.disabled ? 0.5 : 1,
              }}
            >
              <div className="card-header">
                <span className="card-emoji">{card.emoji}</span>
                <span
                  className="card-tag"
                  style={{ display: card.disabled ? 'block' : 'none' }}
                >
                  {card.disabled ? 'Coming Soon' : ''}
                </span>
                <h3>{card.title}</h3>
              </div>
              <div
                className="card-content"
                style={{ backgroundColor: card.bottomColor }}
              >
                <span className="card-icon">
                  <img src={card.icon} alt="icon" />
                </span>
              </div>
            </div>
          ))}
        </div>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          mt={4}
        >
          <Box
            sx={{
              mt: 8,
              bgcolor: theme.palette.mode === 'dark' ? '#2a2a2a' : '#f3f4f6',
              color: '#374151',
              px: 3,
              py: 2,
              borderRadius: 2,
              display: 'inline-block',
            }}
          >
            <Typography variant="body2">
              We're currently focusing only on{' '}
              <strong>Marriage-related questions.</strong> ✨
            </Typography>
            <Typography variant="body2">
              Other life areas will be available soon. Stay tuned as we grow!
            </Typography>
          </Box>

          <Box mt={4}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => navigate('/chat')}
            >
              Skip
            </Button>
          </Box>
        </Stack>
      </Box>
    </BackgroundDiv>
  );
};

// Styled component for animated card
const HoverCard = styled(motion(Paper))(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  height: '100%',
}));

export default AstroWelcome;
